import { Card } from '@/components/ui/card.tsx';

interface MapLegendProps {
	children?: React.ReactNode;
}

export default function MapLegend({ children }: MapLegendProps) {
	return (
		children && (
			<Card className="relative mx-4 my-4 z-10 px-4 py-2 bg-white/95 dark:bg-slate-900/95 backdrop-blur-sm border shadow-lg w-fit">
				{children}
			</Card>
		)
	)
}